<template>
  <v-app>
    <v-container fluid class="fill-height">
      <v-row align="center" justify="center" class="fill-height">
        <v-col class="text-center" cols="12" xl="6" lg="8" md="10" sm="12">
          <particles-bg class="particles" type="custom" :config="config" />
          <MainCard />
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import MainCard from './components/MainCard'
import axo from './assets/axo.js'

export default {
  name: 'App',

  components: {
    MainCard,
  },

  data: () => ({
    config: {
      num: [1, 2],
      rps: 3,
      radius: [100, 200],
      life: [10, 20],
      v: [0.5, 0.7],
      tha: [180,45],
      body: axo,
      alpha: [0.8, 1.0],
      scale: [1.2, 2.7],
      rotate: [-0.2, 0.2],
      position: 'all',
      cross: 'dead',
      random: 20,
      mass: 2
    },
  }),
}
</script>

<style>
.particles {
  background-image: url('./assets/bg.jpg');
  background-size: cover;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
